<template>
  <div class="container">
    <div class="header">
      <div class="header_container">
        <img src="@/assets/logo.png" alt="">
        <div class="header_opt">
          <a  v-for="(item,index) in options" :href="item.href" :key="index">{{item.name}}</a>
       </div>
      </div>
    </div>
    <img class="paper" src="@/assets/paper.png" alt="">
    <div class="lesson_choose">
      课程类型:
      <a  v-for="(item,index) in lessons" :href="item.href" :key="index">{{item.name}}</a>
    </div>
    <!-- main -->
    <div class="main">
     <h2>全部课程</h2>
     <el-button style="margin-left: -89.5%;margin-top:-2%;margin-bottom:1%"  @click="upload">文件上传</el-button>
     <div class="main_container">
       <div class="items"  v-for="(item,index) in arr" :key="index" >
         <div class="label">{{item.videoType? item.videoType:'课程'}}</div>
         <div class="list">
           <div style="margin-top:50%">
            <a @click="preview(item)">视频预览</a><br><br>
            <a @click="download(item)">视频下载</a>
           </div>
         </div>
         <div> 
           <img :src="getbg(item.videoBg)" alt="">
         </div>
          <div style="height: 50px;width:240px;">
            <span>{{item.videoName}}</span>
          </div>
       </div>
     </div>
    </div>
    <up-load ref="dialog" @ok="getPageData"/>
    <video-preview ref="videoPreview"/>
  </div>
</template>

<script>


import {onBeforeMount, onMounted, ref } from 'vue';
import { useStore } from 'vuex'; 
import UpLoad from './modules/upload.vue';
import { downFile } from '@/libs/http';
import { postAction ,getAction} from '@/libs/http';
import VideoPreview from './modules/videoPreview.vue';

export default {
  components:{
    UpLoad,
    VideoPreview
  },
  name: 'homePage',
  setup() {
   
    const options = [
      {name: '首页'},
      {name: '关于大象'},
      {name: '数据中心'},
      {name: '在线学习'},
      {name: '解决方案'},
      {name: '案例展示'},
      {name: '媒体聚焦'},
      {name: '战略合作'},
      {name: '视频中心'},
    ];
    
    const lessons = [
      {name: '全部'},
      {name: '轨道'},
      {name: '信号'},
      {name: '电路'},
      {name: '机械维护'},
      {name: '机电技术'},
      {name: '车辆技术'},
      {name: '电工与电子电路'},
      {name: '管理与调试'},
      {name: '运营管理'},
      {name: '运输'},
      {name: '线路'},
    ];

    const store = useStore();
          
    const info = {
      userName:'001',
      passWord:'123456'
    };
    const login = ()=>{
       postAction('/file_system/sys/login', info).then((res)=>{
         if(res.status == 200){
            let value = res.data.result
            store.commit('setToken', value);
            console.log('zhixingle');
            getPageData();
         }
       })
    };
    let arr = ref([]);
    const getPageData= ()=>{
      getAction('/file_system/jkvideo/jkVideo/list').then((res)=>{
        if(res.status === 200){
          arr.value = res.data.result.records;
        }
      })
    };
    onBeforeMount(() => {
      login();
    });
    const getbg = (videoBg)=>{
        return '/file_system/view/' + videoBg

    }
    const download = (item)=>{
      const id = item.fileId
      downFile({id}).then((data) => {
        if (!data.data) {
          alert('文件下载失败')
          return
        }
        if(data.headers['content-disposition']!=null){
          let fileName = decodeURIComponent(data.headers['content-disposition'].split('=')[1]);
        
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data.data], { type: 'application/octet-stream' }), fileName + '.mp4')
        } else {
          let url = window.URL.createObjectURL(new Blob([data.data], { type: 'application/octet-stream' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          console.log(url)
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
        }
      })
    };
    const videoPreview = ref(null)
    const preview = (item)=>{
      videoPreview.value.show(item)
    }
    const dialog = ref(null);
    const  upload = ()=>{
      dialog.value.show();
      
    }
   return {
     options,
     lessons,
     upload,
     dialog,
     download,
     preview,
     login,
     getPageData,
     arr,
     videoPreview,
     getbg,
   }
  }
}
</script>

<style lang="scss" scoped>
  *{
    padding: 0;
    border: 0;
  }
.container {
  height: 100%;
  width:100%;
  text-align: center;
  .header {
    text-align: center;

    .header_container {
      margin: 0 auto;
      width: 70%;

       img {
          width: 40px;
          height: 40px;
          vertical-align: middle;
        }

      .header_opt {
        height: 60px;
        line-height: 60px;
        display: inline-block;

        a {
          margin-left: 45px;
        }

        a:hover {
          cursor: pointer;
          color: cornflowerblue;
        }
      }
    }
  }
  .paper {
    height: 20%;
    width: 100%;
  }

  .lesson_choose {
    width: 70%;
    height: 40px;
    margin: 0 auto;
    line-height: 40px;
    a {
      margin-left: 2.2%;
    }
    a:hover {
      cursor: pointer;
      color: cornflowerblue;
    }
  }
  .main {
    width: 60%;
    height: 100%;
    margin: 0 auto;
    h2 {
      margin-left: -89.5%;
    }
    .main_container{
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .items {
        margin-left: 3%;
        margin-bottom: 50px;
         img{
           width:240px;
           height: 300px;
         }
         img:hover{
           cursor: pointer;
         }

        .label {
          height: 3%;
          width: 4%;
          margin-top: 5px;
          margin-left: 8%;
          color: #fff;
          line-height: 30px;
          border-radius: 15px;
          background: rgba(0,0,0,.3);
          position: absolute;
        }

        .list {
          opacity: 0;
          position: absolute;
          height: 300px;
          width: 240px;
          background: rgba(0,0,0,.6);
          transition: all 0.3s;

          a {
            width: 20px;
            margin: 0 auto;
            color: #fff;
            text-decoration:none
            
          }
          a:hover {
            cursor: pointer;
            color: cornflowerblue;
          }
        }
        
      }
      .items:hover .list {
        opacity: 1;
      }
    }
  }
  
}

</style>